import { render, staticRenderFns } from "./HotelRefundable.vue?vue&type=template&id=f220bc34&"
import script from "./HotelRefundable.vue?vue&type=script&lang=js&"
export * from "./HotelRefundable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports